








































import CommonBase from "./CommonBase";
import {Component} from "vue-property-decorator";
import rd from "@/modules/vRoutedefs";
import {CanonicalHost} from "@/modules/constants";

@Component
export default class Userterms extends CommonBase {
  get privacyPolicyPath() {
    return rd.about.privacypolicy.path
  }

  readonly baseUrl = `https://${CanonicalHost}`
}
